let val = false;

export const isHydrated = () => val;

export const setHydrated = (newVal) => {
  val = newVal;
};
